module.exports = __webpack_public_path__ + "web/img/img7.c75a9ebf.png";